<template>
  <div id="LmFormBuilder" class="wrapper-content w-100">
    <h1 v-if="pageTitleData">{{pageTitleData}}</h1>
    <LmForm ref="lmFormRef" @onEditMode="onEditMode($event)">
      <portal-target name="destination-after-title" slim/>
      <template v-for="(formRow, index) in formElements" >
        <component
          :id="`${formRow.componentName}-${index}`"
          v-if="formRow.componentName !== 'LmButton' && isVisibleOnlyOnEditMode(formRow) && checkElementPermissionToSee(formRow.componentPermissions)"
          :ref="`componentRef${index}`"
          :disabled="isDisabledOnlyOnEditMode(formRow) || checkElementPermissionToEdit(formRow.componentPermissions) || formRow.componentProps.disabled"
          :key="index"
          :class="formRow.class"
          :is="formRow.componentName"
          :v="$v.formObjectToSendToServer[formRow.formObjectToSendToServerProperty]"
          :showEditButton="isOnPreviewMode"
          v-bind="formRow.componentProps"
          v-model="formObjectToSendToServer[formRow.formObjectToSendToServerProperty]"
          :defaultValue="formRow.componentName === 'LmSuperPowerSelectV2' ? defaultValueOnSuperPower(formRow) : null"
          @edit-button-clicked="click(formRow, index)"
          @onUpdate="formObjectToSendToServer[formRow.formObjectToSendToServerProperty] = $event"
          @change.native="onChange(formRow,$event)"
          @filesToRemoveFromServer="filesToRemove = $event"
          @uploadProcessing="uploadProcessing = $event"
        />
        <!--
          Por https://github.com/lumile/lumbre/issues/724
          Agregamos un condicional para detectar si el componente a injectar es LmSuperPowerSelectV2
          y así poder agregarle la prop :defaultValue para lograr que al modificar el valor del objeto
          se vea reflejado en el superpower.
        -->
        <!--
          - Comenté este código porque agregé la linea 17, cualquier cosa si da problema lo volvemos a descomentar.
          - Recordar que en la linea 8 estaba '&& formRow.componentName !== 'LmSuperPowerSelectV2'' para ocultar si no es un superpower.
          - Tal vez se podría hacer lo mismo para LmButton ya que lo unico diferente es el evento click

          <component
          v-if="formRow.componentName === 'LmSuperPowerSelectV2'"
          :ref="`componentRef${index}`"
          :key="index"
          :class="formRow.class"
          :is="formRow.componentName"
          :v="$v.formObjectToSendToServer[formRow.formObjectToSendToServerProperty]"
          :showEditButton="isOnPreviewMode"
          v-bind="formRow.componentProps"
          v-model="formObjectToSendToServer[formRow.formObjectToSendToServerProperty]"
          :defaultValue="formObjectToSendToServer[formRow.formObjectToSendToServerProperty]"
          @edit-button-clicked="click(formRow, index)"
          @onUpdate="formObjectToSendToServer[formRow.formObjectToSendToServerProperty] = $event"
          @change.native="onChange(formRow,$event)"
        /> -->
        <portal-target v-if="shouldCreatePortal(formRow.componentName)" :key="`destination-key-${index}`" :name="`destination-${index}`" slim/>
        <component
          v-if="conditionsForRenerComponent(formRow)"
          :disabled="conditionsForDisableComponent(formRow)"
          :key="index"
          :class="formRow.class"
          :is="formRow.componentName"
          v-bind="formRow.componentProps"
          :id="formRow.id"
          :action="formRow.actions.click.type"
          @onClick="click(formRow)"
        />
        <p
          v-if="formRow.componentName === 'LmButton' && isDisabledByUserPrivileges(formRow)"
          class="font-italic text-danger col-12"
          :key="'accessDeniedMessage'+index"
        >
          Lo sentimos, no tiene permisos para guardar los cambios.
        </p>
      </template>
      <portal-target name="button-submit" slim/>
    </LmForm>
  </div>
</template>

<script>
import {
  required,
  email,
  minLength,
  maxLength,
  numeric,
  sameAs
} from 'vuelidate/lib/validators'

import commonsApi from '@/api/commons'
import _ from 'lodash'

import LmForm from '@/components/form/LmForm'
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmPassword from '@/components/form/elements/LmPassword'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmNumberInputV2 from '@/components/form/elements/LmNumberInputV2'
import LmDate from '@/components/form/elements/LmDate'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmSelect from '@/components/form/elements/LmSelect'
import LmFormSubtitles from '@/components/form/elements/LmFormSubtitles'
import LmFormEmptySpace from '@/components/form/elements/LmFormEmptySpace'
import LmFormSeparator from '@/components/form/elements/LmFormSeparator'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2.vue'
import LmEditor from '@/components/LmEditor.vue'
import LmLeaFletMap from '@/components/LmLeaFletMap.vue'
import LmHtmlContent from '@/components/form/elements/LmHtmlContent'
import LmPortalTarget from '@/components/form/elements/LmPortalTarget'
import LmColorPicker from '@/components/form/elements/LmColorPicker'
import LmComment from '@/components/LmComment'
import LmRepeatFields from '@/components/form/elements/LmRepeatFields'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmUploadFiles from '@/components/form/elements/LmUploadFiles'
import LmImportFromExcel from '@/components/form/elements/LmImportFromExcel'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import lmToasts from '@/mixins/lmToasts.js'

import {
  checkUserPermissions
  // checkFormElementPermissionToEdit
} from '@/helpers/userPermissions'

export default {
  mixins: [lmToasts],
  components: {
    LmForm,
    LmButton,
    LmTextInput,
    LmPassword,
    LmEmailInput,
    LmNumberInput,
    LmTextArea,
    LmSelect,
    LmFormSubtitles,
    LmFormEmptySpace,
    LmFormSeparator,
    LmDate,
    LmDateTime,
    LmSuperPowerSelectV2,
    LmEditor,
    LmLeaFletMap,
    LmHtmlContent,
    LmPortalTarget,
    LmColorPicker,
    LmComment,
    LmRepeatFields,
    LmCheckbox,
    LmUploadFiles,
    LmImportFromExcel,
    LmNumberInputV2
  },
  data () {
    return {
      registerOfDataWatchDinamically: {},
      pageTitleData: '',
      messageAfterPOSTorPUT: 'Guardado',
      pathToRedirectAfterPOSTorPUT: '/',
      apiRestForHandleAllHttpMethods: '',
      formObjectToSendToServer: {},
      formElements: [], // el array con todos elementos que componen el formulario
      validationsData: {},
      originalValidations: {},
      conditionalOnChange: [],
      isOnEditMode: false,
      formPermissions: {
        allowAccess: [],
        allowCreate: [],
        allowUpdate: []
      },
      userPrivileges: {},
      filesToRemove: [],
      uploadProcessing: false
    }
  },
  validations () {
    const validationsRules = {
      formObjectToSendToServer: {}
    }
    for (const property in this.validationsData) {
      validationsRules.formObjectToSendToServer[property] = {}
      for (const innerObjectProperty in this.validationsData[property]) {
        switch (innerObjectProperty) {
          case 'required':
            if (this.validationsData[property][innerObjectProperty]) {
              validationsRules.formObjectToSendToServer[property][innerObjectProperty] = required
            } else {
              delete validationsRules.formObjectToSendToServer[property][innerObjectProperty]
            }
            break
          case 'email':
            if (this.validationsData[property][innerObjectProperty]) {
              validationsRules.formObjectToSendToServer[property][innerObjectProperty] = email
            } else {
              delete validationsRules.formObjectToSendToServer[property][innerObjectProperty]
            }
            break
          case 'minLength':
            if (this.validationsData[property][innerObjectProperty]) {
              validationsRules.formObjectToSendToServer[property][innerObjectProperty] = minLength(this.validationsData[property][innerObjectProperty])
            } else {
              delete validationsRules.formObjectToSendToServer[property][innerObjectProperty]
            }
            break
          case 'maxLength':
            if (this.validationsData[property][innerObjectProperty]) {
              validationsRules.formObjectToSendToServer[property][innerObjectProperty] = maxLength(this.validationsData[property][innerObjectProperty])
            } else {
              delete validationsRules.formObjectToSendToServer[property][innerObjectProperty]
            }
            break
          case 'numeric':
            validationsRules.formObjectToSendToServer[property][innerObjectProperty] = numeric
            break
          case 'sameAs':
            if (this.validationsData[property][innerObjectProperty]) {
              validationsRules.formObjectToSendToServer[property][innerObjectProperty] = sameAs(this.validationsData[property][innerObjectProperty])
            } else {
              delete validationsRules.formObjectToSendToServer[property][innerObjectProperty]
            }
            break

          default:
            break
        }
      }
    }
    return validationsRules
  },
  props: {
    isOnPreviewMode: {
      type: Boolean,
      default: false
    },
    getComponents: {
      type: Object,
      default: () => ({})
    },
    endpointUriwhereGetComponents: {
      type: String,
      default: ''
    },
    endpointUriWhereGetValuesToLoadInEditMode: {
      type: String,
      default: ''
    }
  },
  methods: {
    conditionsForRenerComponent (component) {
      if (
        component.componentName === 'LmButton' &&
        this.isVisibleOnlyOnEditMode(component) &&
        (component.actions.click.type !== 'delete' || (component.actions.click.type === 'delete' && this.isOnEditMode))
      ) {
        return true
      } else {
        return false
      }
    },
    conditionsForDisableComponent (component) {
      if (
        this.isDisabledOnlyOnEditMode(component) ||
        this.isDisabledByUserPrivileges(component) ||
        component.componentProps.disabled ||
        this.uploadProcessing
      ) {
        return true
      } else {
        return false
      }
    },
    async removeFilesFromServer () {
      try {
        await commonsApi.axiosPostWrapper(`${process.env.VUE_APP_API_URL}removefiles/`, {
          filesToRemove: this.filesToRemove
        })
      } catch (error) {
        console.log(error)
      }
    },
    defaultValueOnSuperPower (formRow) {
      if (formRow?.childrenOf) {
        return this.formObjectToSendToServer[formRow.formObjectToSendToServerProperty]
      } else {
        return formRow?.componentProps?.defaultValue
      }
    },
    isVisibleOnlyOnEditMode (formRow) {
      if (formRow && 'componentProps' in formRow) {
        if ('isVisibleOnlyOnEditMode' in formRow.componentProps) {
          if ((formRow?.componentProps?.isVisibleOnlyOnEditMode && this.isOnEditMode) || !formRow?.componentProps?.isVisibleOnlyOnEditMode) {
            return true
          }
          return false
        } else {
          return true
        }
      }
    },
    isDisabledOnlyOnEditMode (formRow) {
      if (formRow && 'componentProps' in formRow) {
        if ('isDisabledOnlyOnEditMode' in formRow.componentProps) {
          if (formRow?.componentProps?.isDisabledOnlyOnEditMode && this.isOnEditMode) {
            return true
          }
          return false
        } else {
          return false
        }
      }
    },
    isDisabledByUserPrivileges (formRow) {
      if (formRow && 'componentProps' in formRow) {
        if ('type' in formRow.componentProps && formRow.componentProps.type === 'submit') {
          // Crear
          if (!this.userPrivileges.allowCreate && !this.isOnEditMode) {
            return true
          }
          // Actualizar
          if (!this.userPrivileges.allowUpdate && this.isOnEditMode) {
            return true
          }
        }
      }
      return false
    },
    checkElementPermissionToEdit (permissions) {
      // Si no existe la propiedad no aplico la restriccion, esto deberia cambiarse
      // cuando todos los formbuilders requieran permisos para usarse
      // if (!permissions) {
      //   return false
      // }
      // const permissionsList = permissions.allowEdit.map(p => p.codigo_privilegio)
      // const result = checkFormElementPermissionToEdit(permissionsList)
      // if (!result) {
      //   return true
      // }
      // return false
      return false
    },
    checkElementPermissionToSee (permissions) {
      // Si no existe la propiedad no aplico la restriccion, esto deberia cambiarse
      // cuando todos los formbuilders requieran permisos para usarse
      // if (!permissions) {
      //   return true
      // }
      // const permissionsList = permissions.allowToSee.map(p => p.codigo_privilegio)
      // const result = checkFormElementPermissionToEdit(permissionsList)
      // if (result) {
      //   return true
      // }
      // return false
      return true
    },
    onEditMode (event) {
      this.isOnEditMode = event || false
    },
    async onChange (formRow, event) {
      // Evento change en el componente LmSelect y LmSuperPowerSelectV2
      if (formRow.componentName === 'LmSelect' || formRow.componentName === 'LmSuperPowerSelectV2') {
        this.conditionalOnChange.forEach(conditionalOnChange => {
          // Select-0 === Select-0 / Select-1 = ""
          if (formRow.formObjectToSendToServerProperty === conditionalOnChange.depend) this.formObjectToSendToServer[conditionalOnChange.name] = ''
          if (conditionalOnChange.component === 'LmSuperPowerSelectV2') {
            let nref = conditionalOnChange.name
            nref = nref.split('-')
            if (this.$refs[`componentRef${nref[1]}`][0].isVisible === true) this.$refs[`componentRef${nref[1]}`][0].remove()
          }
          this.validationsData[conditionalOnChange.name] = {}
        })
      }
    },
    hideFormElementAndResetHisValidation (formElement) {
      if (formElement.formObjectToSendToServerProperty && this.validationsData && this.originalValidations) {
        this.validationsData[formElement.formObjectToSendToServerProperty] = {}
      }
      if (formElement?.componentProps) {
        formElement.componentProps.isVisible = false
      }
    },
    showFormElementAndSetHisValidation (formElement) {
      if (formElement.formObjectToSendToServerProperty && this.validationsData && this.originalValidations) {
        this.validationsData[formElement.formObjectToSendToServerProperty] = this.originalValidations[formElement.formObjectToSendToServerProperty]
      }
      if (formElement?.componentProps) {
        formElement.componentProps.isVisible = true
      }
    },
    shouldCreatePortal (componentName) {
      return componentName !== 'LmComment'
    },
    async initializeComponent () {
      // Si this.getComponents tiene elementos formbuilder está operando en modo edicion
      // del formulario, ej /FormBuilderUi/edit/[id_de_un_formbuilder]
      if (Object.keys(this.getComponents).length) {
        this.formElements = _.cloneDeep(this.getComponents.formElements)
        this.validationsData = _.cloneDeep(this.getComponents.validations)
        this.originalValidations = _.cloneDeep(this.getComponents.validations)
      } else {
        // Formbuilder esta operando en modo visualizacion
        // Obtenemos toda la informacion del formulario desde la API
        const endPoint = await commonsApi.axiosGetWrapper(this.endpointUriwhereGetComponents)
        this.pageTitleData = endPoint.data.pageTitleData
        this.messageAfterPOSTorPUT = endPoint.data.messageAfterPOSTorPUT
        this.pathToRedirectAfterPOSTorPUT = endPoint.data.pathToRedirectAfterPOSTorPUT
        this.apiRestForHandleAllHttpMethods = endPoint.data.apiRestForHandleAllHttpMethods
        this.formElements = endPoint.data.formElements
        this.validationsData = endPoint.data.validations
        this.originalValidations = _.cloneDeep(endPoint.data.validations)

        // Cargo los permisos del backend
        if (endPoint.data.hasOwnProperty('allowAccess')) {
          this.formPermissions.allowAccess = endPoint.data.allowAccess.map(i => i.codigo_privilegio)
        }
        if (endPoint.data.hasOwnProperty('allowCreate')) {
          this.formPermissions.allowCreate = endPoint.data.allowCreate.map(i => i.codigo_privilegio)
        }
        if (endPoint.data.hasOwnProperty('allowUpdate')) {
          this.formPermissions.allowUpdate = endPoint.data.allowUpdate.map(i => i.codigo_privilegio)
        }
      }
      // Los super power hijos no cargo los valores
      for (const el of this.formElements) {
        if (el?.childrenOf && el?.childrenOf !== null) {
          el.componentProps.disabled = true
        }
      }
    },
    getValueFromFormElements (value) {
      return value?.id || value
    },
    setWatcherForConditionalsFields () {
      this.formElements.forEach(formElement => {
        if (formElement.componentName === 'LmSelect' || formElement.componentName === 'LmSuperPowerSelectV2') {
          if (formElement?.visibilityDependOnConditions?.conditions[0]?.leftValueToCompare) {
            this.conditionalOnChange.push({ name: formElement?.formObjectToSendToServerProperty, component: formElement.componentName, depend: formElement?.visibilityDependOnConditions?.conditions[0]?.leftValueToCompare })
          }
        }

        if (formElement?.visibilityDependOnConditions?.isActive) {
          this.hideFormElementAndResetHisValidation(formElement)
          let condicionalsSameLeftAndcomparation = []
          // eslint-disable-next-line no-unused-expressions
          formElement?.visibilityDependOnConditions?.conditions.forEach(condition => {
            condicionalsSameLeftAndcomparation = formElement?.visibilityDependOnConditions?.conditions.filter(e => e.comparation === condition.comparation && e.leftValueToCompare === condition.leftValueToCompare)
          })
          const watcher = {
            watch: condicionalsSameLeftAndcomparation[0].leftValueToCompare,
            comparation: condicionalsSameLeftAndcomparation[0].comparation,
            conditions: condicionalsSameLeftAndcomparation.map(e => ({ comparation: e.comparation, rightValueToCompare: e.rightValueToCompare }))
          }
          this.$watch(() => this.formObjectToSendToServer[watcher.watch], async function () {
            const leftValueToCompare = this.getValueFromFormElements(this.formObjectToSendToServer[watcher.watch])
            let leftValueToCompareResult = ''

            // chequeo si es un array o string. El resultado siempre viene en tipo string.
            if (JSON.stringify(leftValueToCompare).charAt(0) === '[') {
              leftValueToCompareResult = JSON.stringify(leftValueToCompare)
            } else {
              leftValueToCompareResult = leftValueToCompare
            }
            switch (watcher.comparation) {
              case '===':
                for (const condition of watcher.conditions) {
                  if (leftValueToCompare && leftValueToCompareResult === condition.rightValueToCompare) {
                    this.showFormElementAndSetHisValidation(formElement)
                    break
                  } else {
                    this.hideFormElementAndResetHisValidation(formElement)
                  }
                }
                break
              case '!==':
                for (const condition of watcher.conditions) {
                  if (leftValueToCompare && leftValueToCompareResult !== condition.rightValueToCompare) {
                    this.showFormElementAndSetHisValidation(formElement)
                    break
                  } else {
                    this.hideFormElementAndResetHisValidation(formElement)
                  }
                }
                break
              case '>':
                for (const condition of watcher.conditions) {
                  if (leftValueToCompare && leftValueToCompareResult > condition.rightValueToCompare) {
                    this.showFormElementAndSetHisValidation(formElement)
                    break
                  } else {
                    this.hideFormElementAndResetHisValidation(formElement)
                  }
                }
                break
              case '>=':
                for (const condition of watcher.conditions) {
                  if (leftValueToCompare && leftValueToCompareResult >= condition.rightValueToCompare) {
                    this.showFormElementAndSetHisValidation(formElement)
                    break
                  } else {
                    this.hideFormElementAndResetHisValidation(formElement)
                  }
                }
                break
              case '<':
                for (const condition of watcher.conditions) {
                  if (leftValueToCompare && leftValueToCompareResult < condition.rightValueToCompare) {
                    this.showFormElementAndSetHisValidation(formElement)
                    break
                  } else {
                    this.hideFormElementAndResetHisValidation(formElement)
                  }
                }
                break
              case '<=':
                for (const condition of watcher.conditions) {
                  if (leftValueToCompare && leftValueToCompareResult <= condition.rightValueToCompare) {
                    this.showFormElementAndSetHisValidation(formElement)
                    break
                  } else {
                    this.hideFormElementAndResetHisValidation(formElement)
                  }
                }
                break
            }
          })
        } else {
          if (formElement?.componentProps) {
            formElement.componentProps.isVisible = true
          }
        }
      })
    },
    setWatcher (component, index) {
      /*
        Al tener la posibilidad de mostrar un elemento solo en modo edicion, siendo este un componente dependiente de otro,
        tira error de consola. Agrego "this.$refs[`componentRef${index}`] !== undefined" para evitarlo
      */
      if (
        component.componentName === 'LmSuperPowerSelectV2' &&
        component.childrenOf !== null &&
        this.$refs[`componentRef${index}`] !== undefined
      ) {
        this.$watch(`formObjectToSendToServer.${component['childrenOf']}`, async function (newVal, oldVal) {
          // Intento prevenir la multiple carga de values. TODO: Testear.
          if (newVal?.id === oldVal?.id || newVal?.id === '') {
            return
          }
          // Si es un Array que tenga elementos
          // Que sea un objeto (entendiendo que es un campo single)
          if (newVal && ((Array.isArray(newVal) && newVal.length) || typeof newVal === 'object')) {
            // Obtengo los datos del componente hijo basandose en su padre
            let superPowerOptions = []
            superPowerOptions = await this.$refs[`componentRef${index}`][0].getOptionsFromPath(`${this.formElements[index].componentProps.urlPathFromGetOptions}/${this.formObjectToSendToServer[component.childrenOf].id}`)
            this.formElements[index].componentProps.options = superPowerOptions
            this.formElements[index].componentProps.disabled = false

            // Llamo a los items e inserto el hijo solo en editmode
            if (this.isOnEditMode) {
              const response = await commonsApi.getItemDetail({
                path: this.endpointUriWhereGetValuesToLoadInEditMode
              })
              // Cargo los valores por defecto en el componente hijo
              if (component.componentProps.allOptionsSelectedByDefault) {
                // Si tiene allOptionsSelectedByDefault === true cargo todas las opciones
                this.formObjectToSendToServer[component.formObjectToSendToServerProperty] = superPowerOptions
              } else {
                this.formObjectToSendToServer[component.formObjectToSendToServerProperty] = response[component.formObjectToSendToServerProperty]
              }
            }
          }
          // Si es un array vacio significa que eliminamos el elemento, limpio las options disponibles
          if (Array.isArray(newVal) && !newVal.length) {
            this.formElements[index].componentProps.options = []
            // Limpio el default Value despues de apretar "x"
            this.formElements.forEach(el => {
              if (el.formObjectToSendToServerProperty === component.childrenOf) {
                el.componentProps.defaultValue = []
              }
            })
            this.formElements[index].componentProps.disabled = true
          }
        })
      }
    },
    /*
      Funcion original, si setWatcher no tiene errores, debe eliminarse
    */
    /*
    setWatcherOrig (component, index) {
      const isWatcherInRegister = component.formObjectToSendToServerProperty in this.registerOfDataWatchDinamically
      const componentHasChild = component.childrenOf
      const watchMustBeCreated = component.componentName === 'LmSuperPowerSelectV2' && componentHasChild && !isWatcherInRegister
      const watchMustBeRemoved = isWatcherInRegister && !componentHasChild

      const createWatch = () => {
        const unWatch = this.$watch(`formObjectToSendToServer.${component['childrenOf']}`, async function () {
          if (this.formObjectToSendToServer[component.childrenOf]?.id && this.$refs[`componentRef${index}`] !== undefined) {
            this.formElements[index].componentProps.options = await this.$refs[`componentRef${index}`][0].getOptionsFromPath(`${this.formElements[index].componentProps.urlPathFromGetOptions}/${this.formObjectToSendToServer[component.childrenOf].id}`)
            this.formElements[index].componentProps.disabled = false
          } else {
            this.formElements[index].componentProps.disabled = true
          }
        })
        return unWatch
      }

      const registerWatch = (unWatch) => {
        this.registerOfDataWatchDinamically[component.formObjectToSendToServerProperty] = {
          unWatch
        }
      }

      const setOptionsSuperPowerWhenHasNotChildren = async () => {
        const options = await this.$refs[`componentRef${index}`][0].getOptionsFromPath(this.formElements[index].componentProps.urlPathFromGetOptions)
        this.formElements[index].componentProps.options = options
        this.registerOfDataWatchDinamically[component.formObjectToSendToServerProperty].unWatch()
        delete this.registerOfDataWatchDinamically[component.formObjectToSendToServerProperty]
      }
      if (watchMustBeCreated) {
        const unWatch = createWatch()
        registerWatch(unWatch)
      } else if (watchMustBeRemoved) {
        setOptionsSuperPowerWhenHasNotChildren()
      }
    },
    */
    /**
     * Obtiene desde el backend los datos asociados al registro que se está editando
     *
     * activeEditMode es parte del mixin lmFormMixinV2 que se carga en el componente LmForm
     *
     * emite formLoadingComplete
     */
    async setForm () {
      if (this.endpointUriWhereGetValuesToLoadInEditMode) {
        await this.$refs.lmFormRef.activeEditMode({
          path: this.endpointUriWhereGetValuesToLoadInEditMode,
          id: '',
          paramsMode: true }, 'formObjectToSendToServer')
        this.$emit('formLoadingComplete')
      }
    },
    async click (formRow, index) {
      if (this.isOnPreviewMode) {
        this.$emit('openEditFormElement', index)
      }
      if (formRow?.actions) {
        switch (formRow?.actions?.click?.type) {
          case 'submit':
            await this.$refs.lmFormRef.validationForm(this.$v)
            if (this.endpointUriWhereGetValuesToLoadInEditMode) {
              // Verifico los permisos del usuario para actualizar
              if (!this.userPrivileges?.allowUpdate) {
                return this.lmToastDangerMessage('Lo sentimos, no tiene permisos para realizar esta acción.', 'Error al actualizar')
              }
              this.$refs.lmFormRef.showLoading()
              const pathUpdate = formRow?.actions?.click?.arguments?.pathUpdate || this.apiRestForHandleAllHttpMethods
              // Si tengo parametros asignados a la accion, los agrego al PUT
              const params = formRow?.actions?.click?.params
              const dataToSendToServer = params ? Object.assign({}, this.formObjectToSendToServer, params) : this.formObjectToSendToServer
              await commonsApi.axiosPutWrapper(pathUpdate + this.$route.params.id, dataToSendToServer)
              this.lmToastSuccessMessage(this.messageAfterPOSTorPUT, 'Acción exitosa')
              this.$router.push(this.pathToRedirectAfterPOSTorPUT)
            } else {
              // Verifico los permisos del usuario para guardar
              if (!this.userPrivileges?.allowCreate) {
                return this.lmToastDangerMessage('Lo sentimos, no tiene permisos para realizar esta acción.', 'Error al guardar')
              }
              this.$refs.lmFormRef.showLoading()
              // Si tengo parametros asignados a la accion, los agrego al POST
              const params = formRow?.actions?.click?.params
              const dataToSendToServer = params ? Object.assign({}, this.formObjectToSendToServer, params) : this.formObjectToSendToServer
              await commonsApi.axiosPostWrapper(formRow?.actions?.click?.arguments?.path || this.apiRestForHandleAllHttpMethods, dataToSendToServer)
              this.lmToastSuccessMessage(this.messageAfterPOSTorPUT, 'Acción exitosa')
              this.$router.push(this.pathToRedirectAfterPOSTorPUT)
            }
            break
          case 'cancel':
            this.$router.go(-1)
            break
          case 'delete':
            if (formRow?.actions?.click?.arguments?.deleteMethod === 'put') {
              // Borrado lógico
              const propertyToUpdate = {}
              propertyToUpdate[formRow?.actions?.click?.arguments?.logicDeleteProperty] = formRow?.actions?.click?.arguments?.logicDeleteValue
              propertyToUpdate.id = this.$route.params.id
              await commonsApi.axiosPutWrapper(formRow?.actions?.click?.arguments?.pathDelete || this.apiRestForHandleAllHttpMethods, propertyToUpdate)
              this.lmToastSuccessMessage('Eliminado correctamente.', 'Acción exitosa')
              this.$router.push(this.pathToRedirectAfterPOSTorPUT)
            } else if (formRow?.actions?.click?.arguments?.deleteMethod === 'delete') {
              // Borrado permanente
              await commonsApi.axiosDeleteWrapper(formRow?.actions?.click?.arguments?.pathDelete || this.apiRestForHandleAllHttpMethods + this.$route.params.id)
              this.lmToastSuccessMessage('Eliminado correctamente.', 'Acción exitosa')
              this.$router.push(this.pathToRedirectAfterPOSTorPUT)
            }
            break
          default:
            break
        }
        // Si tengo archivos para eliminar en el servidor
        if (this.filesToRemove.length) {
          await this.removeFilesFromServer()
        }
      }
    },
    setFormElements () {
      this.formElements.forEach((component, index) => {
        if (component.formObjectToSendToServerProperty) {
          this.$set(this.formObjectToSendToServer, component.formObjectToSendToServerProperty, '')
        }
        if (component.componentName === 'LmSuperPowerSelectV2') {
          this.$set(this.formObjectToSendToServer, component.formObjectToSendToServerProperty, { id: '', name: '' })
        }
        if (component.componentName === 'lmSuperPowerSelectV2Multiple' && component?.componentProps.multiple) {
          this.$set(this.formObjectToSendToServer, component.formObjectToSendToServerProperty, [])
        }
        if (
          (component.componentName === 'LmDate' || component.componentName === 'LmDateTime') &&
        this.formElements[index].componentProps &&
        this.formElements[index].componentProps.config
        ) {
          this.formElements[index].componentProps.config.locale = Spanish
        }
        if (component.hasOwnProperty('formObjectToSendToServerProperty')) {
          this.setWatcher(component, index)
        }
        if (component?.componentProps?.urlPathFromGetOptions) {
          this.formElements[index].componentProps.urlPathFromGetOptions = component?.componentProps?.urlPathFromGetOptions
        }
      })
    }
  },
  watch: {
    endpointUriWhereGetValuesToLoadInEditMode () {
      // Este valor puede cambiar si al invocar al formbuilder se pasa como un valor dinamico
      // LmFormBuilderPreview. es un ejemplo de este caso
      this.setForm()
    },
    endpointUriwhereGetComponents () {
      this.initializeComponent()
    },
    'getComponents.pageTitleData' () {
      this.pageTitleData = this.getComponents.pageTitleData
    },
    'getComponents.apiRestForHandleAllHttpMethods' () {
      this.apiRestForHandleAllHttpMethods = this.getComponents.apiRestForHandleAllHttpMethods
    },
    'getComponents.validations' () {
      this.validationsData = _.cloneDeep(this.getComponents.validations)
      this.originalValidations = _.cloneDeep(this.getComponents.validations)
    },
    'getComponents.formElements': {
      handler: function () {
        this.formElements = _.cloneDeep(this.getComponents.formElements)
        this.setFormElements()
        this.setWatcherForConditionalsFields()
      },
      deep: true
    },
    'getComponents': {
      handler: function (val) {
        // Permisos de usuario cuando estamos en FormBuilderUi
        if (val.hasOwnProperty('allowAccess')) {
          this.formPermissions.allowAccess = val.allowAccess.map(i => i.codigo_privilegio)
        }
        if (val.hasOwnProperty('allowCreate')) {
          this.formPermissions.allowCreate = val.allowCreate.map(i => i.codigo_privilegio)
        }
        if (val.hasOwnProperty('allowUpdate')) {
          this.formPermissions.allowUpdate = val.allowUpdate.map(i => i.codigo_privilegio)
        }
        // Check user permissions
        this.userPrivileges = checkUserPermissions(this.formPermissions)
        // Bloqueo el acceso a la edicion de formbuilders si el usuarios no
        // tiene permisos de acceso, pero permito crear nuevos formbuilders
        if (!this.userPrivileges.allowAccess && this.isOnEditMode) {
          this.$router.push('/')
        }
      },
      deep: true,
      inmediate: true
    },
    formObjectToSendToServer: {
      handler: function () {
        // Me aseguro de no enviar mal los "names" de los campos
        for (const item in this.formObjectToSendToServer) {
          if (!this.formElements.some(el => el.formObjectToSendToServerProperty === item)) {
            delete this.formObjectToSendToServer[item]
          }
        }
        this.$emit('formObjectToSendToServerChange', this.formObjectToSendToServer)
      },
      deep: true
    }
  },
  async created () {
    await this.initializeComponent()

    // Si NO estamos dentro de FormBuilderUi
    if (!Object.keys(this.getComponents).length) {
      // Check user permissions
      this.userPrivileges = checkUserPermissions(this.formPermissions)
      if (!this.userPrivileges.allowAccess) {
        this.$router.push('/')
      }
    }

    this.setFormElements()
    await this.setForm()
    this.setWatcherForConditionalsFields()
  }
}
</script>

<style lang="sass" scoped>
::v-deep
  .form-wrapper
    margin-right: -15px
    margin-left: -15px
  #form
    display: -ms-flexbox
    display: -webkit-box
    display: flex
    -ms-flex-wrap: wrap
    flex-wrap: wrap
    width: 100%
</style>
